import React from "react";

function NotAvailable() {
  return (
    <h1 className="not-available">No Movies Avaialble for seleted genre</h1>
  );
}

export default NotAvailable;
